import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
import { handleCatchError } from 'utils/CatchHandler';
import { biometricDevicesApi, setDefaultBiomtericDeviceApi } from 'utils/API/Merchant APIs/AepsApiCalls';
import { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import HomeIcon from '@mui/icons-material/Home';
import LinkIcon from '@mui/icons-material/Link';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { useNavigate } from 'react-router-dom';
import { Alert } from 'antd';
import Spinner from '../LoadingSinner';
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
// eslint-disable-next-line
export default function BiometricDevices({ onDeviceSelect, service, forceShow, onClose, selectedValue, deviceList }) {
    const [open, setOpen] = React.useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [pendingDevice, setPendingDevice] = useState(null);
    console.log('pendingDevice', pendingDevice);
    const [devices, setDevices] = useState([]);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const agentid = localStorage.getItem('id');
    const navigate = useNavigate();
    // const handleClickOpen = () => {
    //     setOpen(true);
    // };

    const handleClose = (event, reason) => {
        if (reason === 'backdropClick') return;
        setOpen(false);
        if (onClose) onClose();
    };

    const handleDeviceClick = (device) => {
        setPendingDevice(device);
        setConfirmOpen(true);
    };

    const handleConfirmSelection = async () => {
        if (!pendingDevice) return;

        try {
            const payload = {
                agentid,
                deviceid: pendingDevice.id // Assuming device object has an id field
            };
            // Call the API to set the default device
            setDefaultBiomtericDeviceApi(payload).catch((err) => console.log('Error setting default device:', err));
        } catch (error) {
            console.log(error);
        }
        onDeviceSelect(pendingDevice.deviceName);
        setConfirmOpen(false);
        setPendingDevice(null);
        handleClose();
    };

    const handleCancelSelection = () => {
        setConfirmOpen(false);
        setPendingDevice(null);
    };

    const fetchUpdateState = async () => {
        // eslint-disable-next-line
        if (deviceList && deviceList.length > 0) {
            setDevices(deviceList);
            // eslint-disable-next-line
            const defaultDevice = deviceList.find((d) => d.default === true);
            if (defaultDevice && !forceShow) {
                // If default exists and we are not forced to show the list, auto-select
                onDeviceSelect(defaultDevice.deviceName);
                if (onClose) onClose();
            } else {
                setOpen(true);
            }
            return;
        }

        setLoading(true);
        const payload = { agentid };
        try {
            const response = await biometricDevicesApi(payload);
            const fetchedDevices = response?.data?.data || [];
            setDevices(fetchedDevices);

            if (response?.data?.status === false) {
                setMessage(response?.data?.message);
                // navigate('/merchant-home');
                setOpen(true); // Always open if there's an error message to show
            } else {
                // Check if there is a default device
                const defaultDevice = fetchedDevices.find((d) => d.default === true);

                if (defaultDevice && !forceShow) {
                    // If default exists and we are not forced to show the list, auto-select
                    onDeviceSelect(defaultDevice.deviceName);
                    if (onClose) onClose(); // Ensure parent knows we are "done"
                } else {
                    // Otherwise show the list
                    setOpen(true);
                }
            }
            setLoading(false);
        } catch (error) {
            console.log(error.message);
            handleCatchError(error);
            setLoading(false);
            setOpen(true); // Open on error so user isn't stuck in limbo? Or maybe better to show error.
        }
    };

    useEffect(() => {
        // handleClickOpen(); // Removed immediate open, now controlled by data
        fetchUpdateState();
        // eslint-disable-next-line
    }, [deviceList, forceShow]);

    const handleHome = () => {
        if (service === 'AEPS') {
            handleClose();
        } else {
            navigate('/merchant-home');
        }
    };
    return (
        <React.Fragment>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
                maxWidth="md"
                fullWidth
                PaperProps={{
                    style: { maxHeight: '80vh', overflowY: 'auto' }
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 16px' }}>
                    {!message ? (
                        <Typography variant="h6" align="center" sx={{ fontWeight: 'bold', flexGrow: 1 }}>
                            Choose Device to Connect
                        </Typography>
                    ) : (
                        <div style={{ width: '500px', marginLeft: '100px', marginTop: '10px' }}>
                            <Alert message={message} type="warning" showIcon />
                        </div>
                    )}
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {service === 'AEPS' ? (
                            <IconButton onClick={handleHome}>
                                <span style={{ fontSize: '1.2rem' }}>✖</span>
                            </IconButton>
                        ) : (
                            <IconButton color="primary" onClick={handleHome}>
                                <HomeIcon />
                            </IconButton>
                        )}
                    </div>
                </div>
                <Grid container spacing={2} padding={2} justifyContent="center">
                    {devices?.map((device) => {
                        const isSelected = device.deviceName === selectedValue;
                        return (
                            <Grid item xs={6} sm={4} md={3} lg={2} key={device?.id}>
                                <Card
                                    sx={{
                                        maxWidth: 150,
                                        minWidth: 120,
                                        maxHeight: 180,
                                        minHeight: 160,
                                        boxShadow: isSelected ? 8 : 3,
                                        border: isSelected ? '2px solid #1976D2' : 'none',
                                        backgroundColor: isSelected ? '#f0f7ff' : 'white',
                                        p: 1,
                                        ':hover': {
                                            boxShadow: 8,
                                            cursor: 'pointer'
                                        }
                                    }}
                                    onClick={() => handleDeviceClick(device)}
                                >
                                    <Tooltip title={device?.deviceFullname} arrow>
                                        <CardContent
                                            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 10 }}
                                        >
                                            <CardMedia
                                                component="img"
                                                height="80"
                                                image={device?.image}
                                                alt={device?.deviceName}
                                                style={{ objectFit: 'contain' }}
                                            />
                                            <Typography
                                                align="center"
                                                sx={{ fontSize: 12, marginTop: 1, fontWeight: isSelected ? 'bold' : 'normal' }}
                                                color={isSelected ? 'primary' : 'text.secondary'}
                                            >
                                                {device?.deviceName}
                                            </Typography>
                                        </CardContent>
                                    </Tooltip>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
                <Spinner loading={loading} />
            </Dialog>

            <Dialog
                open={confirmOpen}
                onClose={handleCancelSelection}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: 16,
                        padding: '10px',
                        boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.1)'
                    }
                }}
            >
                <DialogTitle
                    id="alert-dialog-title"
                    sx={{
                        textAlign: 'center',
                        fontWeight: 'bold',
                        color: '#1976D2',
                        fontSize: '1rem',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 1
                    }}
                >
                    <LinkIcon sx={{ fontSize: 30, color: '#1976D2' }} />
                    Confirm Selection
                </DialogTitle>
                <DialogContent>
                    <DialogContentText
                        id="alert-dialog-description"
                        sx={{
                            textAlign: 'center',
                            fontSize: '0.8rem',
                            color: '#555',
                            marginTop: 1
                        }}
                    >
                        Are you sure you want to set <strong>{pendingDevice?.deviceName}</strong> as your default biometric device?
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center', gap: 2, paddingBottom: 2 }}>
                    <Button
                        onClick={handleCancelSelection}
                        variant="outlined"
                        color="error"
                        startIcon={<CancelIcon />}
                        sx={{
                            textTransform: 'none',
                            borderRadius: 4,
                            padding: '8px 24px',
                            fontWeight: 'bold'
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleConfirmSelection}
                        variant="contained"
                        color="primary"
                        startIcon={<CheckCircleIcon />}
                        sx={{
                            textTransform: 'none',
                            borderRadius: 4,
                            padding: '8px 24px',
                            fontWeight: 'bold',
                            boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
